/**
 * Configuración de sesión y timeout de inactividad
 */

export const SESSION_CONFIG = {
  /**
   * Tiempo de inactividad en milisegundos antes de mostrar la advertencia
   * @default 900000 (15 minutos)
   */
  IDLE_TIME: 15 * 60 * 1000, // 15 minutos
  
  /**
   * Tiempo de advertencia en milisegundos antes del logout automático
   * @default 60000 (1 minuto)
   */
  WARNING_TIME: 60 * 1000, // 1 minuto
  
  /**
   * Tiempo total de sesión antes del logout automático
   * IDLE_TIME + WARNING_TIME = 16 minutos total
   */
  get TOTAL_TIME() {
    return this.IDLE_TIME + this.WARNING_TIME;
  },
} as const;

/**
 * Configuración para diferentes entornos
 * Puedes ajustar estos valores según tus necesidades:
 * 
 * - Aplicaciones bancarias: 5-10 minutos
 * - Aplicaciones empresariales: 15-30 minutos
 * - Aplicaciones de uso general: 30-60 minutos
 */
export const SESSION_PRESETS = {
  STRICT: {
    IDLE_TIME: 5 * 60 * 1000, // 5 minutos
    WARNING_TIME: 60 * 1000, // 1 minuto
  },
  MODERATE: {
    IDLE_TIME: 15 * 60 * 1000, // 15 minutos
    WARNING_TIME: 60 * 1000, // 1 minuto
  },
  RELAXED: {
    IDLE_TIME: 30 * 60 * 1000, // 30 minutos
    WARNING_TIME: 2 * 60 * 1000, // 2 minutos
  },
} as const;
